import { Link, useParams } from "react-router-dom";
import { ArrowLeft, ArrowRight, BookOpen } from "lucide-react";
import { PageLayout } from "@/components/PageLayout";
import { Reveal } from "@/components/Reveal";
import { usePageMeta } from "@/hooks/usePageMeta";
import { ARTICLES } from "@/lib/articles";

export default function ArticlePage() {
  const { slug } = useParams();
  const article = ARTICLES.find((a) => a.slug === slug);

  usePageMeta(
    article ? `${article.title} | J11 Consulting` : "Education Center | J11 Consulting",
    article ? article.description : "Educational resources from J11 Consulting."
  );

  if (!article) {
    return (
      <PageLayout eyebrow="Education Center" title="Resource Not Found" testId="article-not-found">
        <section className="bg-[#0E0E12] py-16">
          <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
            <Link to="/education" data-testid="article-back-link" className="inline-flex items-center gap-2 text-sm font-semibold text-[#D8B54A] hover:text-[#E4C463]">
              <ArrowLeft className="h-4 w-4" />
              Back to Education Center
            </Link>
          </div>
        </section>
      </PageLayout>
    );
  }

  return (
    <PageLayout eyebrow="Education Center" title={article.title} subtitle={article.description} testId="article-page">
      <section className="bg-[#0E0E12] py-14 lg:py-16">
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
          <Reveal>
            <div className="rounded-2xl border border-white/10 bg-[#141419] p-8 sm:p-10" data-testid="article-coming-soon">
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#17171C] shadow-sm">
                <BookOpen className="h-5 w-5 text-[#D8B54A]" strokeWidth={1.8} />
              </span>
              <h2 className="mt-5 font-heading text-xl font-semibold tracking-tight text-[#F2EEE3]">
                This resource is coming soon
              </h2>
              <p className="mt-3 text-sm leading-relaxed text-[#B8B2A6] sm:text-base">
                Our team is preparing this educational resource. In the meantime, you can request a
                free consultation and a member of the J11 Consulting team can discuss this topic with
                you directly.
              </p>
              <div className="mt-6 flex flex-col gap-3 sm:flex-row">
                <Link
                  to="/contact"
                  data-testid="article-consultation-cta"
                  className="group inline-flex h-11 items-center justify-center gap-2 rounded-lg bg-gradient-to-b from-[#E7C766] to-[#AE8924] px-6 text-sm font-semibold text-black transition-colors duration-200 hover:from-[#F2D47E] hover:to-[#C49B2E]"
                >
                  Request a Free Consultation
                  <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5" />
                </Link>
                <Link
                  to="/education"
                  data-testid="article-back-to-education"
                  className="inline-flex h-11 items-center justify-center gap-2 rounded-lg border border-white/25 bg-transparent px-6 text-sm font-semibold text-[#F2EEE3] transition-colors duration-200 hover:bg-[#141419]"
                >
                  <ArrowLeft className="h-4 w-4" />
                  All Resources
                </Link>
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </PageLayout>
  );
}
